var map = {
	"./1.mp4": "724a",
	"./2-2.jpg": "48d9",
	"./2-3.jpg": "1c23",
	"./AKF1.jpg": "c32e",
	"./Korean.png": "2dd4",
	"./QRcode/dy.jpg": "3475",
	"./QRcode/gzh.jpg": "cf6c",
	"./QRcode/ks.jpg": "dbc1",
	"./QRcode/sph.jpg": "a5ee",
	"./QRcode/xhs.jpg": "7b60",
	"./QRcode/xhs96.png": "291d",
	"./QRcode/xhs97.jpg": "3c48",
	"./announcement1.jpg": "bbbe",
	"./announcement2.jpg": "ad73",
	"./announcement3.jpg": "0d89",
	"./announcement4.jpg": "114a",
	"./bimai/cn.png": "75e5",
	"./bimai/jmg.png": "6e50",
	"./bimai/sf.png": "7a71",
	"./bimai/yyp.png": "ad63",
	"./brandCulture/18.png": "4242",
	"./brandCulture/19.png": "1a06",
	"./brandCulture/20.png": "494b",
	"./brandCulture/21.png": "ac54",
	"./brandInformation/14.png": "7040",
	"./brandInformation/15.png": "14bc",
	"./brandInformation/16.png": "aa21",
	"./brandInformation/17.png": "8546",
	"./buyList/buyList1.jpg": "ec91",
	"./buyList/buyList2.jpg": "a5bf",
	"./buyList/buyList3.jpg": "a541",
	"./buyList/buyList4.jpg": "b172",
	"./buyList/buyList5.jpg": "9d7a",
	"./buyNew621/JMG.jpg": "1c6f",
	"./buyNew621/JMGDadi.jpg": "2960",
	"./buyNew621/chunni.jpg": "9177",
	"./buyNew621/fendiye.jpg": "bba1",
	"./buyNew621/meibi.jpg": "59e2",
	"./buyNew621/sanfen.jpg": "b511",
	"./buyNew621/shuangyanpitie.jpg": "6400",
	"./buyNew621/xiezhuangshijin.jpg": "4a83",
	"./buyNew621/xiezhuangshui.jpg": "ec63",
	"./buyNew621/ximiannai.jpg": "62f0",
	"./buyNew621/yanxianjiaobi.jpg": "4bbb",
	"./buyNew621/yanxianyebi.jpg": "fd2d",
	"./buyNew621/yanying.jpg": "7718",
	"./chanpin.jpg": "f5c5",
	"./details/chunni.png": "7a37",
	"./details/fendiye.png": "3d68",
	"./details/jiemaodadi.png": "7240",
	"./details/jiemaogao.png": "eceb",
	"./details/meibi.png": "7d34",
	"./details/sanfen.png": "7261",
	"./details/shuangyanpitie.png": "cb79",
	"./details/xiezuangshijin.png": "8b4a",
	"./details/xiezuangshui.png": "4d92",
	"./details/ximiannai.png": "6142",
	"./details/yanxianjiaobi.png": "bbbb",
	"./details/yanxianyebi.png": "8ebd",
	"./details/yanying.png": "5c30",
	"./gonggao86.png": "a56a",
	"./guohui.png": "ec4b",
	"./header.png": "2dc7",
	"./left.png": "34eb",
	"./logo.png": "9d64",
	"./main.jpg": "e35e",
	"./main/cn.png": "378a",
	"./main/jmg.png": "989e",
	"./main/sf.png": "644b",
	"./main/yyp.png": "8389",
	"./main93.jpg": "4d88",
	"./main_96.jpg": "27a5",
	"./main_old.jpg": "090a",
	"./main_old2.jpg": "c8ff",
	"./mobile/banner.jpg": "8d11",
	"./mobile/chunni001.jpg": "b28e",
	"./mobile/chunni02.jpg": "6df2",
	"./mobile/footer.jpg": "9b9f",
	"./mobile/jiaobi002.jpg": "d51c",
	"./mobile/sanfen003.jpg": "9f75",
	"./mobile/sanfen03.jpg": "049a",
	"./mobile/ximiannai004.jpg": "8d90",
	"./mobile/yanyingpan01.jpg": "e981",
	"./news/news1-1.png": "6221",
	"./news/news1-2.png": "9b1c",
	"./news/news2-1.png": "8e19",
	"./newsList/1/1.jpg": "16d4",
	"./newsList/10/1.jpg": "2f69",
	"./newsList/10/2.jpg": "4d9f",
	"./newsList/11/1.jpg": "007d",
	"./newsList/11/2.jpg": "d1f1",
	"./newsList/11/3.jpg": "d720",
	"./newsList/12/1.jpg": "35ba",
	"./newsList/13/1.jpg": "7cad",
	"./newsList/2/1.jpg": "dcb4",
	"./newsList/3/1.jpg": "9332",
	"./newsList/4/1.jpg": "d3a7",
	"./newsList/4/2.jpg": "2d55",
	"./newsList/4/3.jpg": "9c03",
	"./newsList/4/4.jpg": "1c9e",
	"./newsList/4/5.jpg": "da59",
	"./newsList/4/6.jpg": "6e02",
	"./newsList/4/7.jpg": "a6b6",
	"./newsList/4/8.jpg": "f6c1",
	"./newsList/4/9.jpg": "2bde",
	"./newsList/5/1.jpg": "88ea",
	"./newsList/5/10.jpg": "303c",
	"./newsList/5/11.jpg": "df37",
	"./newsList/5/12.jpg": "78fc",
	"./newsList/5/13.jpg": "862c",
	"./newsList/5/2.jpg": "df75",
	"./newsList/5/3.jpg": "87d7",
	"./newsList/5/4.jpg": "b567",
	"./newsList/5/5.jpg": "fa6e",
	"./newsList/5/6.jpg": "a8b7",
	"./newsList/5/7.jpg": "8725",
	"./newsList/5/8.jpg": "11c3",
	"./newsList/5/9.jpg": "256b",
	"./newsList/6/1.jpg": "6119",
	"./newsList/6/10.jpg": "8d60",
	"./newsList/6/11.jpg": "484b",
	"./newsList/6/12.jpg": "940d",
	"./newsList/6/13.jpg": "1d37",
	"./newsList/6/14.jpg": "9e4f",
	"./newsList/6/15.jpg": "14ae",
	"./newsList/6/16.jpg": "f0a7",
	"./newsList/6/17.jpg": "7463",
	"./newsList/6/18.jpg": "bc67",
	"./newsList/6/19.jpg": "03bd",
	"./newsList/6/2.jpg": "4e32",
	"./newsList/6/20.jpg": "4f87",
	"./newsList/6/21.jpg": "3c7e",
	"./newsList/6/22.jpg": "24e0",
	"./newsList/6/23.jpg": "8e8c",
	"./newsList/6/24.jpg": "b266",
	"./newsList/6/3.jpg": "7771",
	"./newsList/6/4.jpg": "d604",
	"./newsList/6/5.jpg": "dcdf",
	"./newsList/6/6.jpg": "ee92",
	"./newsList/6/7.jpg": "1ec9",
	"./newsList/6/8.jpg": "07d6",
	"./newsList/6/9.jpg": "35a6",
	"./newsList/7/1.jpg": "11e8",
	"./newsList/7/2.jpg": "9895",
	"./newsList/7/3.jpg": "7be3",
	"./newsList/8/1.jpg": "5b5e",
	"./newsList/8/2.jpg": "c404",
	"./newsList/9/1.jpg": "07ba",
	"./newsList/9/2.jpg": "69a1",
	"./product/cn.jpg": "23de",
	"./product/cn_small.png": "a9c0",
	"./product/jmgH.jpg": "a727",
	"./product/jmgZ.jpg": "2949",
	"./product/jmg_small.png": "37d0",
	"./product/sanfen.jpg": "6593",
	"./product/xzs.jpg": "54a0",
	"./product/yyp.jpg": "00cc",
	"./product/yyp_small.png": "36c38",
	"./query.jpg": "3d6d",
	"./right.png": "0f2a",
	"./眼线笔.jpg": "9d0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";